import { call, select, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../../../../Data/ActionTypes';
import JourneyOutcome from '../../../../Data/JourneyOutcome';
import JourneyOutcomeDetail from '../../../../Data/JourneyOutcomeDetail';
import { incrementMetric } from '../../../../Services/Datadog';
import { getErrorTypeTag } from '../clientApiError.helpers';
import reportJourneyOutcomeOnce from '../reportJourneyOutcomeOnce';
import { captureWithSubmissionId } from './captureWithSubmissionId';
import {
  TERMINAL_STATUSES,
  isTerminalCutoff,
} from '../GetLeadStatus/getLeadStatus';

const getOutcomeDetail = (leadStatus) =>
  TERMINAL_STATUSES.includes(leadStatus?.status)
    ? JourneyOutcomeDetail.LEAD_ALREADY_RELEASED
    : JourneyOutcomeDetail.LEAD_NEVER_CONFIRMED;

export function* reportBookingNotConfirmableWorker() {
  const submissionId = yield select((state) => state.submission?.id);

  try {
    const leadStatus = yield select(
      (state) => state.clientApiJourney?.leadStatus
    );

    const { outcome, outcomeDetail } = isTerminalCutoff(leadStatus)
      ? {
          outcome: JourneyOutcome.TIMEOUT,
          outcomeDetail: JourneyOutcomeDetail.TERMINAL_CUTOFF,
        }
      : {
          outcome: JourneyOutcome.GOAL_UNMET,
          outcomeDetail: getOutcomeDetail(leadStatus),
        };

    yield call(reportJourneyOutcomeOnce, { outcome, outcomeDetail });
  } catch (error) {
    incrementMetric({
      name: 'clientApiBookingNotConfirmableError',
      tags: { type: getErrorTypeTag(error) },
    });
    captureWithSubmissionId({ error, submissionId });
  }
}

export default function* reportBookingNotConfirmableWatcher() {
  yield takeEvery(
    ActionTypes.REPORT_CLIENT_API_BOOKING_NOT_CONFIRMABLE,
    reportBookingNotConfirmableWorker
  );
}
